import { useState } from "react";
import { Switch } from "V2.0/common/switch";
import { message } from "antd";
import { putTranscriptionSettings } from "../../service";
import { showErrorToast } from "V2.0/utils";

function NoiseCancellationEnableSwitch(props) {
  const {
    isNoiseCancellationEnabled,
    onToggleNoiseCancellationEnabled,
    disabled,
  } = props;

  return (
    <Switch
      color="emerald"
      checked={isNoiseCancellationEnabled}
      onClick={onToggleNoiseCancellationEnabled}
      disabled={disabled}
    />
  );
}

export default function NoiseCancellation(props) {
  const {
    transcriptionSettings,
    workspaceId,
    assistantId,
    syncAssistant,
    locked,
  } = props;

  const [settings, setSettings] = useState({
    denoiserEnabled: Boolean(transcriptionSettings?.denoiserEnabled),
  });
  const [saving, setSaving] = useState(false);

  // Saves immediately on toggle (same UX as before); rolls the switch back if the
  // update fails so the UI never shows a state the backend doesn't have.
  async function handleToggleNoiseCancellationEnabled() {
    if (saving) return;
    const nextValue = !settings.denoiserEnabled;
    setSettings({ denoiserEnabled: nextValue });
    setSaving(true);
    message.loading("Updating Settings");

    try {
      const response = await putTranscriptionSettings({
        workspaceId,
        assistantId,
        payload: { denoiserEnabled: nextValue },
      });

      if (response.status === 200) {
        message.destroy();
        message.success("Settings Updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            transcriptionSettings: response.data,
          };
        });
      }
    } catch (e) {
      message.destroy();
      setSettings({ denoiserEnabled: !nextValue });
      showErrorToast(e, "Failed to update Noise Cancellation");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="flex justify-between w-3/5 border rounded-lg p-4">
      <div className="">
        <p className="text-md font-semibold text-gray-900">
          Noise Cancellation
        </p>
        <p className="text-sm mt-1 text-gray-500">
          Suppress background noise on the caller&apos;s audio before
          transcription, for clearer speech recognition in noisy places
        </p>
      </div>
      <div>
        <NoiseCancellationEnableSwitch
          isNoiseCancellationEnabled={settings.denoiserEnabled}
          onToggleNoiseCancellationEnabled={
            handleToggleNoiseCancellationEnabled
          }
          disabled={locked || saving}
        />
      </div>
    </div>
  );
}
